import React, { useState } from "react"
import { Select, Button } from "antd"
import { PRIMARY_BTN_STYLE } from "./constants"

const { Option } = Select

const SelectDropdownQuestion = ({ wizardMeta, answered, onRespond }) => {
  const { options, defaultValue } = wizardMeta
  const [value, setValue] = useState(defaultValue || options[0])

  return (
    <div
      className="wizard-select-dropdown"
      style={{
        marginTop: 8, display: "flex", gap: 8, alignItems: "center",
      }}
    >
      <Select value={value} onChange={setValue} disabled={answered} style={{ minWidth: 160 }}>
        {options.map((opt) => (
          <Option key={opt} value={opt}>{opt}</Option>
        ))}
      </Select>
      {!answered && (
        <Button style={PRIMARY_BTN_STYLE} onClick={() => onRespond({ value })}>
          Confirm
        </Button>
      )}
    </div>
  )
}

export default SelectDropdownQuestion
